import styled from '@emotion/styled';
import { colors, spacing } from 'component-library';

export const ContainerRowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.mediumLow};
`;

export const ContainerRowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.xsmall};
  width: 100%;
`;

export const ContainerRowCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: ${spacing.xsmall};
  padding: ${spacing.small};
  background-color: ${colors.background.grey};
  border: 1px solid ${colors.monochrome.grey20};
  border-radius: ${spacing.xxsmall};
`;

export const ContainerFieldsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: ${spacing.small};
`;

export const ContainerImageWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: ${spacing.mediumHigh};
  height: ${spacing.mediumHigh};
`;

export const GrowingFieldWrapper = styled.div`
  flex: 1;
  min-width: 180px;
`;

export const AmountWrapper = styled.div`
  flex-shrink: 0;
  width: 106px;
`;

export const PalletCollarAmountWrapper = styled.div`
  flex-shrink: 0;
  width: 166px;
`;

export const DateWrapper = styled.div`
  flex-shrink: 0;
  width: 178px;
`;

export const StackedDateWrapper = styled.div`
  width: 287px;
  max-width: 100%;
`;
